<template>
	<div>
	    <h1 class="page-title" style="border-bottom: 1px solid #dae2e4; padding-bottom: 20px;">Register Aafiyat Community</h1>
	    <p style="margin-bottom:24px;">By creating an account you can upload file, write content and many more.</p>
	    <div v-if="tacBlock" id="stylized" style="max-width: none;">
	        <div class="row">
	            <label style="padding-top:5px;">AAFIYAT SEARCH WEBSITE POLICIES</label>
	            <div class="overflow-auto" style="max-width: none; max-height: 400px;">
	            	<p><span>(https://search.aafiyatgroup.com/) is owned and operated by Aafiyat Holdings Sdn. Bhd.<br>&nbsp;I hereby agree that;</span></p>
	            	<ul style="list-style-type: disc;">
	            	    <li><span>All materials contained on this site, including all designs, drawings, photographs and any other content contained on this site are protected by copyright, trademark or any other proprietary right owned by Aafiyat Holdings Sdn. Bhd., except as otherwise stated.</span></li>
	            	    <li><span>No part of this website may be modified, copied, resubmitted, published, displayed, licensed, transferred, sold or otherwise maintained for commercial purposes in any form without prior written permission of Aafiyat Holdings Sdn. Bhd except for articles which are attached with the sharing button, provided that the user must give appropriate credit to Aafiyat Holdings Sdn. Bhd (with a link to the formal publication of Aafiyat Search)</span></li>
	            	    <li><span>The contents of this website are intended to provide users of this site with nutritional guideline, Islamic references, scientific research, product and company information.&nbsp;</span></li>
	            	    <li><span>The contents of this site are deemed to be accurate and up-to-date and at the date stated on the front page of this site.</span></li>
	            	    <li><span>In addition, careful observation has been made in providing the information on this site and Aafiyat Holdings Sdn. Bhd. will not be liable for any inaccuracies or incomplete information on this site.</span></li>
	            	    <li><span>The last version of any document on this site is a copy of the original documentation filed with Aafiyat Holdings Sdn. Bhd.&nbsp;</span></li>
	            	    <li><span>No part of this site is permitted to link to any of these websites without the prior written permission of Aafiyat Holdings Sdn. Bhd.</span></li>
	            	    <li><span>Any website linked to this site is not under the control of Aafiyat Holdings Sdn. Bhd.</span></li>
	            	    <li><span>Aafiyat Holdings Sdn. Bhd. is not responsible for the content of any linked website, or any changes to that website.</span></li>
	            	    <li><span>Requests for permission to link to this site must be made in writing to Aafiyat Holdings Sdn. Bhd.&nbsp;</span></li>
	            	    <li><span>This site has links to other sites; however, the privacy policy or policy applies only to this website (https://search.aafiyatgroup.com/). Other websites associated with this site may have different privacy policies and visitors are advised to review and understand the privacy policy for each site you visit.</span></li>
	            	</ul>
	            	<p><span>If this website policy changes in any way, it will be updated on this page. Regularly review this page to keep you updated on the information collected</span></p>
	            </div>
	        </div>
	        <div class="row">
	            <label class="form-check">
	              <input class="form-check-input" v-on:click="tickAgree" ref="checkboxAgree" type="checkbox" style="margin-top: 2px;">
	              <span class="form-check-label">I Agree with Website Policies</span>
	          </label>
	        </div> 
	        <div class="row">
	            <input type="submit" value="Submit" v-on:click="submitAgree" :disabled="beforeAgree">
	        </div>
	    </div>
	    <div v-if="regBlock" id="stylized">
	    	<form method="post" action="/register">
	    		<input name="_token" type="hidden" :value="csrfToken">   
		        <div class="row">
		            <label style="padding-top:5px;">Name</label>
		            <input type="text" maxlength="50" name="name" v-model="inputForm.name" required="" class="inputfield" />
		            <small class="input-hint" v-if="!nameIsRequired">Name is required</small>
		        </div>
		        <div class="row">
		            <label style="padding-top:5px;">Email</label>
		            <input type="text" maxlength="50" name="email" v-model="inputForm.email" required="" class="inputfield" />
		            <small class="input-hint" v-if="!emailIsRequired">Email is required</small>
		            <small class="input-hint" v-if="emailIsValid">Email is invalid</small>
		        </div>
		        <div class="row">
		            <label style="padding-top:5px;">Password</label>
		            <input type="password" maxlength="50" name="password" v-model="inputForm.password" required="" class="inputfield" autocomplete="false" />
		            <small class="input-hint" v-if="!passwordIsRequired">Password is required</small>
		            <small class="input-hint" v-if="passwordIsLong">Password must 8 long</small>
		        </div>
		        <div class="row">
		            <label style="padding-top:5px;">Confirm Password</label>
		            <input type="password" maxlength="50" name="password_confirmation" v-model="inputForm.password_confirmation" required="" class="inputfield" autocomplete="false" />
		            <small class="input-hint" v-if="!confirmPasswordIsRequired">Confirm Password is required</small>		            
		            <small class="input-hint" v-if="confirmPasswordIsMatch">Confirm Password is not match</small>		            
		        </div>
		        <div class="row">
		        	<label style="padding-top:5px;">{{ randOne }} * {{ randTwo }} =</label>
		        	<input type="text" v-model="inputForm.captcha" maxlength="5" name="check" class="inputfield" style="width:50px;">
		            <small class="input-hint" v-if="!mathIsValid">Math result is required</small>		            		        	
		            <small class="input-hint" v-if="mathIsCorrect">Math result incorrect</small>		            		        	
		        </div>
		        <div class="row">
		        	<small>Remarks:</small>
		            <br><small>1) Recommended using Gmail for Email address.</small>		            		        			        	
		            <br><small>2) Please use combination character & number to strong the password.</small>		            		        			        	
		        </div>
		        <div class="row">
		            <input type="submit" value="Register" :disabled="validateForm">
		        </div>
			</form>		       
	    </div>

	</div>	   
</template>

<script>
	export default {       
		data() {
			return {
				csrfToken: "",
				beforeAgree: true,
				tacBlock: true,
				regBlock: false,
				randOne: this.randomNumber1(),
				randTwo: this.randomNumber2(), 
				inputForm: [{
					name: "",
					email: "",
					password: "",
					password_confirmation: "",
					captcha: "",
				}],
			};
		},
		mounted() {
			this.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
		},
		methods: {
			tickAgree() {
				if (this.$refs.checkboxAgree.checked == true) {
					this.beforeAgree = false;
				}
				else {
					this.beforeAgree = true;					
				}
			},
			submitAgree() {
				this.tacBlock = false;
				this.regBlock = true;
			},
			randomNumber1 : function(){
				return Math.floor(Math.random() * (10 - 1 + 1)) + 1;
			},
			randomNumber2 : function(){
				return Math.floor(Math.random() * (10 - 1 + 1)) + 1;
			},
			validEmail: function (email) {
				var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return re.test(email);
			},
		},
		computed: {
  			validateForm() {
  			    if (!this.inputForm.name) {
  			        return true;
  			    }
  			    if (!this.inputForm.email) {
  			        return true;
  			    }
  			    if (!this.validEmail(this.inputForm.email)) {
  			        return true;
  			    }
  			    if (!this.inputForm.password) {
  			        return true;
  			    }
  			    if (!this.inputForm.password_confirmation) {
  			        return true;
  			    }
  			    if (this.inputForm.password != this.inputForm.password_confirmation) {
  			    	return true;
  			    }
  			    if (this.inputForm.password.length < 8) {
  			    	return true;
  			    }
  			    if (!this.inputForm.captcha) {
  			        return true;
  			    }
  			    if (this.inputForm.captcha != this.randOne * this.randTwo) {
  			    	return true;
  			    }
  			},
  			nameIsRequired() {
  				return this.inputForm.name;
  			},
  			emailIsRequired() {
  				return this.inputForm.email;
  			},
  			emailIsValid() {
  				return this.inputForm.email && !this.validEmail(this.inputForm.email);
  			},
  			passwordIsRequired() {
  				return this.inputForm.password;
  			},
  			passwordIsLong() {
  				return this.inputForm.password && this.inputForm.password.length < 8;
  			},
  			confirmPasswordIsRequired() {
  				return this.inputForm.password_confirmation;
  			},
  			confirmPasswordIsMatch() {
  				return this.inputForm.password_confirmation && this.inputForm.password_confirmation != this.inputForm.password;
  			},
  			mathIsValid() {
  				return this.inputForm.captcha;
  			},
  			mathIsCorrect() {
  				return this.inputForm.captcha && this.inputForm.captcha != this.randOne * this.randTwo;
  			},
		},

	}
</script>

<style scoped>
.input-hint {
	display: block;
	color: #ff0000;
}

</style>